import { isLocal, env, isServer } from '@lcsc-ui/utils/baseUrl';
import domains from '@lcsc-ui/utils/domains';
import { doGet } from '@lcsc-ui/utils/request';

// staticdata服务
let suffix = '';
if (isLocal) {
  suffix = 'dev';
} else if (['fat', 'uat', 'dev'].includes(env)) {
  suffix = env;
}

// 打包环境下使用：inner-staticdata， 非打包环境下使用：staticdata
const staticdataServer = !isServer
  ? `https://${env === 'pro' ? '' : env === 'local' ? 'dev' : `${env}`}staticdata.szlcsc.com`
  : `https://${env === 'pro' ? 'inner-' : env === 'local' ? 'dev' : `${env}-inner-`}staticdata.szlcsc.com`;

const resourceList = `${staticdataServer}/common/data/resource-list.json`;
const mroResourceList = `${staticdataServer}/common/data/mro-resource-list.json`;
const catalogList = `${staticdataServer}/common/data/resource-catalog-list-new.json`;
const mroCatalogList = `${staticdataServer}/common/data/mro-resource-catalog-list.json`;
const websiteSection = `${staticdataServer}/common/data/op-website-section.json`;
const advertisingHeader = `${staticdataServer}/common/data/op-advertising-header.json`;
const websiteJlcgroup = `${staticdataServer}/common/data/www-website-jlcgroup.json`;

const StaticdataApi = {
  resourceList,
  mroResourceList,
  catalogList,
  mroCatalogList,
  websiteSection,
  advertisingHeader,
  websiteJlcgroup,
};

export default StaticdataApi;

export function resourceCatalogList() {
  if (isLocal) {
    return doGet(domains.lcscWwwUrl, `/resource/catalog/list`);
  }
  return doGet(staticdataServer, `/common/data/resource-catalog-list-new.json`);
}
